import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import 'react-loading-skeleton/dist/skeleton.css'
import App from "./App";
import MenuContext from "./Context/MenuOpen/MenuContext";
import LoadingContext, { LoadingCon } from "./Context/LoadingContext/LoadingContext";
import { HelmetProvider } from "react-helmet-async";
import SeoHelmet from "./Components/SeoHelmet";
import './i18n';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
      <HelmetProvider>
  <React.StrictMode>
    <LoadingContext>

    <MenuContext>
      <App />
    </MenuContext>
    </LoadingContext>
  </React.StrictMode>
      </HelmetProvider>
);
